const NAVIGATION = {
    SELECT: {
        event: 'navigation',
        eventProperties: {
            description: 'User click on app navigation',
            selection: '',
        },
    },
    SELECTIONS: {
        NAV_LOGO: 'navlogo',
    },
};

export default NAVIGATION;
